import {
    BasicInfoBeneficiary,
    TermsBeneficiary,
    EvaluationFormBeneficiary,
    DocumentsBeneficiary,
    ObjectionBeneficiary,
    } from './components';
    import { getLocalString, localNames } from "utils/localisation.service";
    import locale from 'antd/lib/date-picker/locale/el_GR';
  
  export const stepsObjection = [
    {
      name: 'BASICFORM',
      label: 'Βασικά Στοιχεία',
      Component: BasicInfoBeneficiary,
      id: 0,
    },
    {
      name: 'DOCUMENTS',
      label: 'Έγγραφα',
      Component: DocumentsBeneficiary,
      id: 1,
    },
    {
      name: 'TERMS',
      label: 'Όροι και Προϋποθέσεις',
      Component: TermsBeneficiary,
      id: 2,
    },
    {
      name: 'EVALUATIONFORM',
      label: 'Αξιολόγηση από Φορέα Υλοποίησης',
      Component: EvaluationFormBeneficiary,
      id: 3,
    },
    {
      name: 'OBJECTIONFORM',
      label: 'Ένσταση',
      Component: ObjectionBeneficiary,
      id: 4,
    },
  ];